import { Box, BoxProps } from '@mui/material'
import { useEffect, useState } from 'react'
import { BoxMenuShadow } from './Menu.styles'
import Item from './item'

import { useAction } from '@/hooks/useAction'
import { useLocalStorage } from '@/hooks/useLocalStorage'
import { useMenu } from '@/hooks/useMenu'

import logo from '@/assets/logo_horizontal.png'
import mini from '@/assets/logo_retratil.png'

import { PATHS } from '@/utils/paths'
import { PermissionResource } from '@/types/permissions.types'

export interface IMenuItem extends BoxProps {
  title: string
  icon: string
  redirect?: string
  subcategory?: any[]
  active?: boolean
  isToggleButton?: boolean
}

function Menu() {
  const { toggle, updateValue, updateMenusAvailables, menusAvailables } =
    useMenu()
  const { SET_ACTION_NAME, updateValue: updateActionContext } = useAction()
  const [user] = useLocalStorage<any>('user')
  const [menu, setMenu] = useState<Array<IMenuItem>>([])

  useEffect(() => {
    if (toggle) {
      updateValue()
    }
  }, [])

  useEffect(() => {
    handleSetMenu()
    Promise.all([SET_ACTION_NAME(''), updateActionContext('')])
  }, [])

  function redirectToPrivacity() {
    const win: Window = window
    win.open('/politica-privacidade', '_blank')
  }

  // ID deve ter o mesmo valor da permissão do usuário retornado no login para ser exibido
  const list = [
    {
      id: PermissionResource.DASHBOARD,
      title: 'Dashboard',
      icon: 'Dashboard',
      redirect: '/dashboard'
    },
    {
      id: PermissionResource.DASHBOARD_MANAGEMENT_ANALYSIS,
      title: 'Análises gerenciais',
      icon: 'analises-gerenciais',
      redirect: '/analises-gerenciais'
    },
    {
      id: PermissionResource.INSPECTION,
      title: 'Vistorias',
      icon: 'Car',
      redirect: PATHS.inspections.index
    },
    {
      id: PermissionResource.REFUND,
      title: 'Reembolso',
      icon: 'Refund',
      redirect: PATHS.refund.index
    },
    {
      id: PermissionResource.PREPARATION,
      title: 'Preparação',
      icon: 'Repair',
      redirect: PATHS.preparation.index
    },
    {
      id: PermissionResource.PRECIFICATION,
      title: 'Precificação',
      icon: 'Price_Tag',
      redirect: PATHS.precification.index
    },
    {
      id: PermissionResource.VEHICLE,
      title: 'Local atual do ativo',
      icon: 'ativo',
      redirect: PATHS.currentActiveLocation.list
    },
    {
      id: 'parametrizacao',
      title: 'Parametrizações',
      icon: 'cogs',
      redirect: '/parametrizacao',
      subcategory: [
        {
          id: PermissionResource.PHOTO_FLOW_PARAMETRIZATION,
          title: 'Fluxo de Fotos',
          redirect: PATHS.parametrization.photoFlow.index
        },
        {
          id: PermissionResource.EVALUATION_TYPE_PARAMETRIZATION,
          title: 'Tipo de Avaliação',
          redirect: PATHS.parametrization.evaluationType.index
        },
        // {
        //   id: PermissionResource.EVALUATION_TYPE_PARAMETRIZATION,
        //   title: 'Checklist',
        //   redirect: PATHS.parametrization.checklist.index
        // },
        {
          id: PermissionResource.PHOTO_SECTION_PARAMETRIZATION,
          title: 'Seções de Fotos',
          redirect: PATHS.parametrization.photoSections.index
        },
        {
          id: PermissionResource.INSPECTION_PHOTO_PARAMETRIZATION,
          title: 'Fotos de Vistoria',
          redirect: PATHS.parametrization.inspectionPhotos.index
        },
        {
          id: PermissionResource.CATEGORY,
          title: 'Categorias',
          redirect: PATHS.parametrization.category.index
        },
        {
          id: PermissionResource.INSPECTION_CATEGORY,
          title: 'Categoria da vistoria',
          redirect: PATHS.parametrization.inspectionCategories.index
        },
        {
          id: PermissionResource.BREAKDOWN,
          title: 'Avarias',
          redirect: PATHS.parametrization.breakdowns.index
        },
        {
          id: PermissionResource.SLA,
          title: 'SLA',
          redirect: PATHS.parametrization.sla.index
        },
        {
          id: PermissionResource.PRODUCT,
          title: 'Produtos',
          redirect: PATHS.parametrization.products.list
        },
        {
          id: PermissionResource.SERVICE,
          title: 'Serviços',
          redirect: PATHS.parametrization.services.list
        },
        {
          id: PermissionResource.PROVIDER,
          title: 'Prestadores',
          redirect: PATHS.parametrization.providers.list
        },
        {
          id: PermissionResource.ITEM_SERIES,
          title: 'Itens de série',
          redirect: PATHS.parametrization.serialItem.list
        },
        {
          id: PermissionResource.ACCESSORY,
          title: 'Acessórios',
          redirect: PATHS.parametrization.accessories.list
        },
        {
          id: PermissionResource.INSPECTION_PARAMETRIZATION,
          title: 'Vistoria',
          redirect: PATHS.parametrization.inspection.index
        },
        {
          id: PermissionResource.APPRAISAL_COMPANY,
          title: 'Empresa Avaliadora',
          redirect: PATHS.parametrization.appraisalCompany.list
        },
        {
          id: PermissionResource.BRAND,
          title: 'Marcas',
          redirect: PATHS.parametrization.brands.index
        }
      ]
    },
    {
      id: PermissionResource.USER,
      title: 'Usuários',
      icon: 'user',
      redirect: PATHS.users.index
    },
    {
      id: PermissionResource.PROFILE,
      title: 'Perfil',
      icon: 'perfil',
      redirect: '/profile'
    },
    {
      id: PermissionResource.FILE_MANAGER,
      title: 'Arquivos',
      icon: 'files',
      redirect: PATHS.files.index
    },
    {
      id: PermissionResource.INTEGRACOES,
      title: 'Integrações',
      icon: 'sync',
      redirect: PATHS.integrations.index
    }
  ]

  const handleSetMenu = () => {
    const menusAvailableTemp = getMenusAvailables()
    menusAvailableTemp?.push('ativo', 'arquivos')

    if (!menusAvailableTemp) return

    if (menusAvailableTemp?.length) {
      const dataTemp = list.map((x) => {
        if (x.subcategory?.length)
          x.subcategory = x.subcategory.filter((item) =>
            menusAvailableTemp.includes(item.id.toLowerCase())
          )

        return x
      })

      const result = dataTemp.filter(
        (item) =>
          menusAvailableTemp.includes(item.id.toLowerCase()) ||
          item.subcategory?.length
      )

      setMenu(result ?? [])
    }
  }

  const getMenusAvailables = () => {
    if (menusAvailables?.length) return menusAvailables

    const userData = localStorage.getItem('user-data')

    if (!userData) return null

    const data = JSON.parse(userData)
    const menusAvailableTemp = data.menusAvailable?.map((x: any) =>
      x.toLowerCase()
    )

    updateMenusAvailables(menusAvailableTemp)

    return menusAvailableTemp
  }

  return (
    <Box
      width="100%"
      height={{ xs: 'calc(100vh + 50px)', md: '100vh' }}
      bgcolor="white"
      minWidth={toggle ? 76 : { xs: '100vw', md: 264 }}
      maxWidth={toggle ? 76 : { xs: '100vw', md: 264 }}
      position="relative"
      display="flex"
      flexDirection="column"
      flexGrow={1}
      overflow="auto"
      style={{
        transition: 'all 0.2s linear',
        zIndex: 99
      }}
    >
      <BoxMenuShadow style={{ width: toggle ? '100%' : '' }}>
        <Box
          display="flex"
          height="72px"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={toggle ? mini : logo}
            alt="car"
            width="100%"
            style={{
              maxWidth: toggle ? '37px' : '110px'
            }}
          />
        </Box>
        <Box
          overflow="auto"
          flexGrow={1}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            {menu.map((item, index) => {
              return (
                <Item
                  redirect={item.redirect}
                  icon={item.icon}
                  title={toggle ? '' : item.title}
                  key={index}
                  subcategory={item.subcategory || []}
                />
              )
            })}
            <div onClick={redirectToPrivacity}>
              <Item
                icon="privacity"
                title={toggle ? '' : 'Política de privacidade'}
                subcategory={[]}
              />
            </div>
          </Box>
          <div onClick={() => updateValue()}>
            <Box
              mt="4px"
              width="100%"
              borderTop="1px solid #8F8E9126"
              paddingBottom="46px"
            >
              <Item
                icon="ArrowClose"
                isToggleButton={true}
                title={toggle ? '' : 'Retrair menu'}
              />
            </Box>
          </div>
        </Box>
      </BoxMenuShadow>
    </Box>
  )
}
export default Menu
